import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';

const Settings = () => {
  const { user, logout } = useAuth()
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div>
      <h1>Settings</h1>

      <section>
        <h3>Account Info</h3>
        <p><strong>Name:</strong> {user?.name}</p>
        <p><strong>Phone:</strong> {user?.phone}</p>
        <p><strong>Email:</strong> {user?.email}</p>
      </section>

      <section style={{ marginTop: '20px' }}>
        <button onClick={handleLogout} style={{ backgroundColor: '#e74c3c', color: 'white', padding: '10px 20px', border: 'none', borderRadius: '4px',  cursor: 'pointer'}}>
          Logout
        </button>
      </section>
    </div>
  );
};

export default Settings;
